var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMagenta)?_c('tmo-digital-header',{attrs:{"theme":"light"}}):_c('tmo-digital-header',{attrs:{"brand":"metro","client-id":"metro"}})}
var staticRenderFns = []

export { render, staticRenderFns }